.badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 22px;
  padding: 0 9px;
  border-radius: var(--vc-radius-pill);
  font-size: var(--vc-text-xs);
  font-weight: var(--vc-weight-semibold);
  line-height: 1;
  white-space: nowrap;
  background: var(--badge-bg, var(--vc-gray-soft));
  color: var(--badge-fg, var(--vc-text-secondary));
  letter-spacing: 0.01em;

  &.sm {
    height: 18px;
    padding: 0 7px;
    font-size: 10px;
  }

  .dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
    flex: none;
  }

  &.outline {
    background: transparent;
    box-shadow: inset 0 0 0 1px var(--badge-fg, var(--vc-border-strong));
  }

  &.gray {
    --badge-bg: var(--vc-gray-soft);
    --badge-fg: var(--vc-text-secondary);
  }
  &.blue {
    --badge-bg: var(--vc-blue-soft);
    --badge-fg: var(--vc-blue);
  }
  &.purple {
    --badge-bg: var(--vc-purple-soft);
    --badge-fg: var(--vc-purple);
  }
  &.green {
    --badge-bg: var(--vc-green-soft);
    --badge-fg: var(--vc-green);
  }
  &.amber {
    --badge-bg: var(--vc-amber-soft);
    --badge-fg: var(--vc-amber);
  }
  &.red {
    --badge-bg: var(--vc-red-soft);
    --badge-fg: var(--vc-red);
  }
  &.pink {
    --badge-bg: var(--vc-pink-soft);
    --badge-fg: var(--vc-pink);
  }
  &.teal {
    --badge-bg: var(--vc-teal-soft);
    --badge-fg: var(--vc-teal);
  }
  &.brand {
    --badge-bg: var(--vc-brand);
    --badge-fg: #fff;
  }
  &.dark {
    --badge-bg: var(--vc-text);
    --badge-fg: #fff;
  }
}

.count {
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: var(--vc-radius-pill);
  background: var(--vc-brand-soft);
  color: var(--vc-brand);
  font-size: 10px;
  font-weight: var(--vc-weight-bold);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
